import { render } from "./crm-loyalty.vue?vue&type=template&id=39ee7424&scoped=true"
import script from "./crm-loyalty.vue?vue&type=script&lang=js"
export * from "./crm-loyalty.vue?vue&type=script&lang=js"

import "./crm-loyalty.vue?vue&type=style&index=0&id=39ee7424&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ee7424"]])

export default __exports__